import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import actionTypes from '../types/detailTypes';

export const setClaimData = (details: any): Action<any> =>
  updateAction(actionTypes.SET_CLAIM_DATA, details);

export const fetchClaimDetails = (payload: any): Action<any> => {
  return updateAction(actionTypes.CLAIM_DETAILS, payload);
};

export const fetchClaimDetailsPayerType = (payload: any): Action<any> => {
  return updateAction(actionTypes.CLAIM_DETAILS_PAYER_TYPE, payload);
};

export const compareClaimDetail = (payload: any): Action<any> => {
  return updateAction(actionTypes.VERIFY_CLAIM, payload);
};

export const reloadCurrentPage = (): Action<any> => {
  return updateAction(actionTypes.RELOAD_CURRENT_PAGE);
};

export const resubmitClaim = (payload: any, onSuccess: any, onError: any): Action<any> => (
  {type: actionTypes.RE_SUBMIT, ...{payload, onSuccess, onError}}
);

export const setClaimMandatoryClassifications = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_CLAIM_MANDATORY_CLASSIFICATION, payload);

export const setIsCashlessSubmit = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_IS_CASHLESS_SUBMIT, payload);

export const setLinkAbhaClicked = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_LINK_ABHA_CLICK, payload);

export const setInpatientReconsiderClicked = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_INPATIENT_RECONSIDER_ACTION, payload);

export const setLinkMoreDocsToAbha = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_LINK_MORE_DOCS_TO_ABHA, payload);

export const setLinkedToAbha = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_LINKED_TO_ABHA, payload);

export const setSinceYearDate = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_SINCE_YEAR_DATE, payload);

export const setReasonForCancellation = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_REASON_FOR_CANCELLAION, payload);

export const manualStatusSync = (data: any, onSyncSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.MANUAL_STATUS_SYNC, { data, onSyncSuccess, onError });

export const showClaimDetailData = (payload: any): Action<any> => {
  return updateAction(actionTypes.SHOW_CLAIM_DETAIL_DATA, payload);
};

export const isCancelClicked = (payload: any): Action<any> => {
  return updateAction(actionTypes.IS_CANCEL_CLICKED, payload);
};

export const setTimeLineColorCode = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_TIMELINE_COLOR_CODE, payload);
};

export const setIsDeleteModal = (payload: any): Action<any> => {
  return updateAction(actionTypes.IS_DETAIL_MODAL, payload);
};

export const setIsArtemisClaim = (payload: boolean): Action<any> => {
  return updateAction(actionTypes.SET_ARTEMIS_CLAIM, payload);
};
